import React, { useContext } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { MenuContext } from './context/menuContext'

const POSICION_MENU_FAVORITOS = 2
const LINK_TIENDAS_OFICIALES = 'TiendasOficiales'
const LINK_PUBLICACIONES = 'Publicaciones'

const buildearEstaActivo =
  ({ esTiendasOficiales, esPublicaciones, tiendasOficialesActivo }) =>
  ({ isActive }) => {
    if (esTiendasOficiales) return tiendasOficialesActivo
    if (esPublicaciones) return isActive && !tiendasOficialesActivo
    return isActive
  }

const MenuFavoritos = () => {
  const { menus } = useContext(MenuContext)
  const { pathname } = useLocation()

  const tiendasOficialesActivo = pathname
    .toLowerCase()
    .includes(LINK_TIENDAS_OFICIALES.toLowerCase())

  return (
    <>
      {menus
        .filter((menu) => menu.idMenuPosicion === POSICION_MENU_FAVORITOS)
        .map((menuFavorito) => {
          const esTiendasOficiales = menuFavorito.link === LINK_TIENDAS_OFICIALES
          const esPublicaciones = menuFavorito.link === LINK_PUBLICACIONES

          const estaActivo = buildearEstaActivo({
            esTiendasOficiales,
            esPublicaciones,
            tiendasOficialesActivo
          })

          return (
            <div key={menuFavorito.idMenu}>
              <NavLink
                to={`/${menuFavorito.link}`}
                className={(props) =>
                  estaActivo(props) ? 'acceso-directo active' : 'acceso-directo'
                }
              >
                {menuFavorito.nombre}
              </NavLink>
            </div>
          )
        })}
    </>
  )
}

export default React.memo(MenuFavoritos)
